import { render, staticRenderFns } from "./FxedTop.vue?vue&type=template&id=56619a7c&scoped=true"
import script from "./FxedTop.vue?vue&type=script&lang=js"
export * from "./FxedTop.vue?vue&type=script&lang=js"
import style0 from "./FxedTop.vue?vue&type=style&index=0&id=56619a7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56619a7c",
  null
  
)

export default component.exports